/** @returns {string} Stable id for a widget grid item */
export function createWidgetId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return `widget-${crypto.randomUUID()}`;
  }
  return `widget-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/** Ensure every widget has a stable id for react-grid-layout */
export function ensureWidgetIds(layout) {
  if (!Array.isArray(layout)) return [];
  return layout.map((widget, index) => ({
    ...widget,
    id: widget.id || createWidgetId(),
  }));
}

/** Convert saved widget layout to react-grid-layout items */
export function layoutToGridItems(layout) {
  return ensureWidgetIds(layout).map((widget) => ({
    i: widget.id,
    x: widget.position?.x ?? 0,
    y: widget.position?.y ?? 0,
    w: widget.size?.width ?? 4,
    h: widget.size?.height ?? 2,
    minW: 2,
    minH: 2,
    maxW: 12,
    maxH: 8,
  }));
}

/** Apply react-grid-layout drag/resize results back to widget configs */
export function applyGridLayoutChange(layout, newGridLayout) {
  return layout.map((widget) => {
    const item = newGridLayout.find((entry) => entry.i === widget.id);
    if (!item) return widget;
    return {
      ...widget,
      position: { x: item.x, y: item.y },
      size: { width: item.w, height: item.h },
    };
  });
}
